import React, {useState} from 'react';
import {Col, Popover, PopoverBody, Row} from 'reactstrap';
import className from "classnames";
import {getAgeGroupDiv} from "../../../../../util/utility";
import assets from '../../../../../util/assets';
import "./index.css";
import ProgressiveImage from "react-progressive-image";
import DropdownItem from "../dropdown-item/DropdownItem";
import Button from "reactstrap/lib/Button";
import PropTypes from "prop-types";
import {PricingSmall} from "../pricing/small";
import {PricingType} from "../pricing/type";
import Zoom from "react-medium-image-zoom";

const PublishListItem = (props) => {

    const [popoverOpen, setPopoverOpen] = useState(false);
    const toggle = () => setPopoverOpen(!popoverOpen);
    const container = className("no-margin", {
        "my-library-table-header": !props.isPricing,
        "publish-list-item-container": !props.isPricing
    })

    const setPricingClassName = className({
        "outline-primary": props.content.pricing.type === "free",
        "outline-secondary": props.content.pricing.type === "paid"
    })

    const getGallery = (gallery) => {

        if (props.gallery !== null && props.gallery !== undefined && gallery !== null) {
            const result = props.gallery.filter(content => content.id === gallery.id);

            if (Array.isArray(result) && result.length > 0) {
                return result[0];
            } else {
                return gallery;
            }
        }

        return null;
    }

    const [isGallerySectionOpen, setIsGallerySectionOpen] = useState(props.content.gallery !== null && !props.isPricing);
    const toggleIsGallerySectionOpen = () => setIsGallerySectionOpen(!isGallerySectionOpen);

    const VideoItem = (props) => {
        return (
            <div className="my-library-thumbnail-dynamic-bg"
                 style={{backgroundImage: "linear-gradient(to bottom, rgba(26, 26, 26, 0.32), rgba(41, 41, 41, 0.53)),url('" + props.content.thumbnail_url + "')"}}>

                <PricingType content={props.content}/>
                <div className="my-library-thumbnail-duration-publish-container">
                                            <span
                                                className="my-library-thumbnail-duration-publish-text">{props.content.durationFormatted}</span>
                </div>
            </div>
        )
    }

    const PictureItem = (props) => {
        return (
            <Zoom>
                <img alt="my-library-thumbnail"
                     className="my-library-thumbnail"
                     src={props.content.url}/>
            </Zoom>
        )
    }

    return (
        <div className={container}
             key={`my-library-row-${props.index}`}>
            <Row className="publish-list-item-display-flex-align-items-center">
                <Col md={props.isPricing ? "12" : "10"} className="no-padding">
                    <div className="display-flex">

                        <ProgressiveImage
                            delay={1000}
                            src={props.content.thumbnail_url}
                            placeholder="placeholder"
                        >
                            {(src, loading) => {
                                return loading ? (
                                        <img alt="my-library-thumbnail" className="my-library-thumbnail-dynamic"
                                             src={assets.clipstore.placeholder}/>
                                    ) :
                                    (
                                        props.content.type === "picture"
                                            ?
                                            PictureItem(props)
                                            :
                                            VideoItem(props)
                                    )

                            }}
                        </ProgressiveImage>

                        <div className="my-library-content-list">
                            <div className="my-library-content-title">
                                <span>{props.content.title}</span>
                            </div>
                            <div className="my-library-content-description">{props.content.description}</div>
                            <div
                                className="my-library-content-date display-flex-justify-content-flex-start-align-items-center">
                                <div className="badge badge-sm text-white">
                                    {getAgeGroupDiv(props.content.age_group, "age-group-24")}
                                </div>
                                {
                                    !props.isPricing && <PricingSmall pricing={props.content.pricing}/>
                                }
                            </div>
                        </div>
                    </div>
                </Col>

                {
                    !props.isPricing &&
                    <Col md="2" style={{textAlign: 'right'}} className="no-padding ">
                        <div className="my-library-content-action">
                            {
                                props.content.type !== "picture" &&
                                <Button color={setPricingClassName} onClick={() => {
                                    props.setPricing(props.content.id);
                                }}>
                                    {
                                        props.content.pricing.type === "free" ? "SET PRICING" : "EDIT PRICING"
                                    }
                                </Button>
                            }
                            <img src={popoverOpen ? assets.more_selected : assets.more}
                                 className="rotate-90"
                                 id={`mylibrary-more-${props.index}`}/>
                        </div>
                    </Col>
                }
                {
                    !props.isPricing &&
                    <Popover placement="bottom" isOpen={popoverOpen} target={`mylibrary-more-${props.index}`}
                             toggle={toggle}>
                        <PopoverBody className="my-library-actions-pop-over-body">
                            <div>
                                <DropdownItem
                                    isFetching={props.publish_videos.isFetching}
                                    onClick={() => {
                                        toggle();
                                        props.addToGallery(props.content.id,props.content.type);
                                    }}
                                    icon={assets.clipstore.more.duplicateVideo}
                                    text={"Add to gallery"}
                                />

                                <DropdownItem
                                    isFetching={props.duplicate_videos.isFetching}
                                    onClick={() => {
                                        toggle();
                                        props.editVideo(props.content.id,props.content.type);
                                    }}
                                    icon={assets.clipstore.more.editVideo}
                                    text={"Edit Content"}
                                />

                                <DropdownItem
                                    isFetching={props.delete_videos.isFetching}
                                    onClick={() => {
                                        toggle();
                                        props.deleteVideo(props.content.id,props.content.type);
                                    }}
                                    icon={assets.clipstore.more.deleteVideo}
                                    text={"Delete Content"}
                                />


                            </div>
                        </PopoverBody>
                    </Popover>
                }
            </Row>

            {
                props.content.gallery !== null &&
                <Row className="my-library-gallery-bottom-container no-margin" onClick={() => {
                    props.openGallery(props.content.gallery.id)
                }}>
                    <Col md="6" className="added-to-safety-conc no-padding">
                        <img src={assets.clipstore.added_to_gallery} alt="added to gallery icon"
                             style={{marginRight: 4}}/>
                        Added to <span
                        className="primary-color">{getGallery(props.content.gallery) ? getGallery(props.content.gallery).title : ""}</span>
                    </Col>
                    <Col md="6" style={{textAlign: 'right'}} className="videos-included-in no-padding ">
                        {getGallery(props.content.gallery) ? (getGallery(props.content.gallery).videos ? getGallery(props.content.gallery).videos.length : 1) : 1} videos
                        included in the package
                    </Col>
                </Row>
            }

        </div>
    );
}

PublishListItem.propTypes = {
    index: PropTypes.number.isRequired,
    openGallery: PropTypes.func.isRequired,
    content: PropTypes.object.isRequired,
    thumbnailClicked: PropTypes.func.isRequired,
    setPricing: PropTypes.func.isRequired,
    addToGallery: PropTypes.func.isRequired,
    editVideo: PropTypes.func.isRequired,
    deleteVideo: PropTypes.func.isRequired,
    isPricing: PropTypes.bool.isRequired,
};

// Specifies the default values for props:
PublishListItem.defaultProps = {
    index: 1,
    content: {},
    thumbnailClicked: () => {

    },
    setPricing: () => {

    },
    addToGallery: () => {

    },
    editVideo: () => {

    },
    deleteVideo: () => {

    },
    isPricing: false
};

export default PublishListItem;